/**
* Template Name: MyResume - v4.10.0
* Template URL: https://bootstrapmade.com/free-html-bootstrap-template-my-resume/
* Author: BootstrapMade.com
* License: https://bootstrapmade.com/license/
*/

(function()
{
    $(document).ready(function()
    {
        /**
         * Easy selector helper function
         */
        const select = (el,all = false) =>
        {
            if (el == "#/") return;
            el = el.trim()
            let comp = $(el);
            if (all)
            {
                return [...comp]
            } else
            {
                return comp[0];
            }
        }

        /**
         * Easy event listener function
         */
        const on = (type,el,listener,all = false) =>
        {
            $(el).on(type,listener);
        }

        /**
         * Easy on scroll event listener 
         */
        const onscroll = (el,listener) =>
        {
            el.addEventListener('scroll',listener)
        }

        /**
         * Navbar links active state on scroll
         */
        let navbarlinks = select('#navbar .scrollto',true)
        const navbarlinksActive = () =>
        {
            let position = window.scrollY + 200
            navbarlinks.forEach(navbarlink =>
            {
                if (!navbarlink.hash) return
                let section = select(navbarlink.hash)
                if (!section) return
                if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight))
                {
                    navbarlink.classList.add('active')
                } else
                {
                    navbarlink.classList.remove('active')
                }
            })
        }
        window.addEventListener('load',navbarlinksActive)
        onscroll(document,navbarlinksActive)

        /**
         * Scrolls to an element with header offset
         */
        const scrollto = (el) =>
        {
            let elementPos = select(el).offsetTop
            window.scrollTo({
                top: elementPos,
                behavior: 'smooth'
            })
        }

        /**
         * Back to top button
         */
        let backtotop = select('.back-to-top')
        if (backtotop)
        {
            const toggleBacktotop = () =>
            {
                if (window.scrollY > 100)
                {
                    backtotop.classList.add('active')
                } else
                {
                    backtotop.classList.remove('active')
                }
            }
            window.addEventListener('load',toggleBacktotop)
            onscroll(document,toggleBacktotop)
        }

        /**
         * Mobile nav toggle
         */
        on('click','.mobile-nav-toggle',function(e)
        {
            select('body').classList.toggle('mobile-nav-active')
        })

        /**
         * Scrool with ofset on links with a class name .scrollto
         */
        on('click','.scrollto',function(e)
        {
            if (select(this.hash))
            {
                e.preventDefault()

                let body = select('body')
                if (body.classList.contains('mobile-nav-active'))
                {
                    body.classList.remove('mobile-nav-active')
                    let navbarToggle = select('.mobile-nav-toggle')
                    navbarToggle.classList.toggle('fa-home')
                    navbarToggle.classList.toggle('bi-x')
                }
                scrollto(this.hash)
            }
        },true)

        /**
         * Scroll with ofset on page load with hash links in the url
         */
        window.addEventListener('load',() =>
        {
            if (window.location.hash)
            {
                if (select(window.location.hash))
                {
                    scrollto(window.location.hash)
                }
            }
        });

        /**
         * Skills animation
         */
        const progress_skills_animation = () =>
        {
            let skilsContent = select('.skills-content');
            if (skilsContent)
            {
                let steps = 0;
                new Waypoint({
                    element: skilsContent,
                    offset: '100%',
                    handler: function(direction)
                    {
                        let progress = select('.progress .progress-bar',true);
                        progress.forEach((el) =>
                        {
                            steps += 30;
                            setTimeout(() =>
                            {
                                el.style.width = el.getAttribute('aria-valuenow') + '%'
                            },
                                // steps
                                Math.floor(Math.random() * (1500 - 0 + 1) + 0)
                            );
                        });
                    }
                })
            }
        }

        window.addEventListener('load',progress_skills_animation)

        /**
         * Porfolio isotope and filter
         */
        window.addEventListener('load',() =>
        {
            let proyectosContainer = select('.proyectos-container');
            if (proyectosContainer)
            {
                let proyectosIsotope = new Isotope(proyectosContainer,{
                    itemSelector: '.proyectos-item'
                });

                let proyectosFilters = select('#proyectos-flters li',true);

                on('click','#proyectos-flters li',function(e)
                {
                    e.preventDefault();
                    proyectosFilters.forEach(function(el)
                    {
                        el.classList.remove('filter-active');
                    });
                    this.classList.add('filter-active');

                    proyectosIsotope.arrange({
                        filter: this.getAttribute('data-filter')
                    });
                    proyectosIsotope.on('arrangeComplete',function()
                    {
                        AOS.refresh()
                    });
                },true);
            }

        });

        /**
         * Initiate proyectos lightbox 
         */
        // const proyectosLightbox = GLightbox({
        //     selector: '.proyectos-lightbox'
        // });

        /**
         * Initiate proyectos details lightbox 
         */
        // const proyectosDetailsLightbox = GLightbox({
        //     selector: '.proyectos-details-lightbox',
        //     width: '90%',
        //     height: '90vh'
        // });

        /**
         * Animation on scroll
         */
        window.addEventListener('load',() =>
        {
            // AOS.init({
            //     duration: 1000,
            //     easing: 'ease-in-out',
            //     once: true,
            //     mirror: false
            // })
        });

        /**
         * Initiate Pure Counter 
         */
        // new PureCounter();

        /**
         * Preloader
         */
        let preloader = select('#preloader');
        if (preloader)
        {
            preloader.remove()
        }
        // {
        //     duration: 1000,
        //     easing: 'ease-in-out',
        //     once: true,
        //     mirror: false
        // }
        AOS.init(
            {
                duration: 1000,
            }
        )
        // alert("ok")
    });
})();